import React from "react";
import MessengerCustomerChat from "react-messenger-customer-chat";

const LiveChat = () => {
  return (
    <div>
      <MessengerCustomerChat 
        pageId="101370648951799" 
        appId="957663201750674" 
      />
    </div>
  );
};

export default LiveChat;
